import {
  PAYMENT_DIALOG_CONTENT,
  PaymentStatus,
} from "../../../constants/payment";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import React from "react";
import { Typography } from "../../core/Typography/Typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { useStyles } from "./PaymentDialog.style";

interface PaymentDialogProps {
  status: PaymentStatus;
  open: boolean;
  onClose: () => void;
  onTryAgain?: () => void;
  onStartPlaying?: () => void;
}

export const PaymentDialog: React.FC<PaymentDialogProps> = ({
  status,
  open,
  onClose,
  onTryAgain,
  onStartPlaying,
}) => {
  const dialogContent = PAYMENT_DIALOG_CONTENT[status];
  const classes = useStyles();

  const getMainAction = () => {
    const action = dialogContent.mainAction;
    if (!action) return undefined;

    const onClick = (() => {
      switch (status) {
        case PaymentStatus.SUCCESS:
          return onStartPlaying ?? onClose;
        case PaymentStatus.CANCELLED:
        case PaymentStatus.FAILED:
          return onTryAgain ?? onClose;
        case PaymentStatus.PENDING:
          return onClose;
        default:
          return onClose;
      }
    })();

    return {
      text: action.text,
      onClick,
      id: action.id,
    };
  };

  const getSecondAction = () => {
    const action = dialogContent.secondAction;
    if (!action) return undefined;

    return {
      text: action.text,
      onClick: onClose,
      id: action.id,
    };
  };

  return (
    <Dialog
      mainAction={getMainAction()}
      secondAction={getSecondAction()}
      open={open}
      className={classes.dialogContent}
    >
      <Typography
        variant={TypographyVariant.HeadingH3Bold}
        className={classes.header}
      >
        {dialogContent.header}
      </Typography>

      <div className={classes.content}>
        {dialogContent.content.map((paragraph, index) => (
          <Typography
            key={index}
            variant={TypographyVariant.BodyB3Medium}
            color={TypographyColor.Default}
            className={classes.contentText}
          >
            {paragraph}
          </Typography>
        ))}
      </div>
    </Dialog>
  );
};
